import { mergeToken } from 'antd/es/theme/internal';

// export type PickerToken = {
//   colorHoverBorder: string;
// };

var antPrefixCls = '.ant-picker';
var genPickStyle = function genPickStyle(token) {
  var _ref;
  return _ref = {}, _ref[antPrefixCls] = {
    padding: '5px 11px'
  }, _ref['.ant-picker-small'] = {
    padding: '3px 7px'
  }, _ref;
};
var genDropdownStyle = function genDropdownStyle(token) {
  var _cellCls, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _dropdownCls, _ref8;
  var dropdownCls = ".ant-picker-dropdown";
  var cellCls = ".ant-picker-cell";
  return _ref8 = {}, _ref8[dropdownCls] = (_dropdownCls = {}, _dropdownCls[cellCls] = (_cellCls = {}, _cellCls[cellCls + "-inner"] = {
    borderRadius: '24px !important'
  }, _cellCls), _dropdownCls['.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner'] = {
    backgroundColor: token.colorFillSecondary + '!important',
    fontWeight: 600
  }, _dropdownCls['.ant-picker-content th'] = {
    color: token.colorTextSecondary
  }, _dropdownCls['.ant-picker-quarter-panel,.ant-picker-month-panel'] = {
    '.ant-picker-cell-inner': {
      width: '56px'
    }
  }, _dropdownCls[".ant-picker-date-panel .ant-picker-body"] = {
    padding: '8px 20px'
  }, _dropdownCls[".ant-picker-year-panel,.ant-picker-quarter-panel,.ant-picker-month-panel"] = {
    '.ant-picker-body': {
      padding: '6px 8px'
    }
  }, _dropdownCls['.ant-picker-quarter-panel .ant-picker-content'] = {
    height: 40
  }, _dropdownCls['.ant-picker-week-panel-row-range-hover td'] = {
    '&:before': {
      backgroundColor: token.colorFillSecondary
    }
  }, _dropdownCls['.ant-picker-week-panel-row:hover td'] = {
    '.ant-picker-cell-inner': {
      color: token.colorText + '!important'
    },
    '&:before': {
      backgroundColor: token.colorFillSecondary
    }
  }, _dropdownCls['.ant-picker-ranges'] = {
    height: '48px',
    '.ant-picker-ok .ant-btn': {
      height: '32px'
    }
  }, _dropdownCls[antPrefixCls + "-now"] = (_ref2 = {}, _ref2[antPrefixCls + "-now-btn"] = {
    color: token.colorPrimaryText,
    '&:hover': {
      color: token.colorPrimaryTextHover
    }
  }, _ref2), _dropdownCls[cellCls + "-selected"] = (_ref4 = {}, _ref4[cellCls + "-inner"] = (_ref3 = {
    fontWeight: 500
  }, _ref3["&::before"] = {
    top: '21px !important'
  }, _ref3), _ref4), _dropdownCls[antPrefixCls + "-content"] = (_ref7 = {}, _ref7[cellCls + "-in-view" + cellCls + "-today"] = (_ref6 = {}, _ref6[cellCls + "-inner"] = (_ref5 = {}, _ref5["&::before"] = {
    border: 0,
    fontSize: '24px',
    color: token.colorPrimaryText,
    fontWeight: 500,
    content: '"·"',
    position: 'absolute',
    top: '21px'
  }, _ref5), _ref6), _ref7), _dropdownCls), _ref8;
};
var datePickerStyleFn = function datePickerStyleFn(token) {
  var pickerToken = mergeToken(token, {
    pickerCellCls: antPrefixCls + "-cell",
    pickerCellInnerCls: antPrefixCls + "-cell-inner"
  });
  return [genDropdownStyle(pickerToken), genPickStyle()];
};

export { datePickerStyleFn };
